import { onReady } from './util/onReady';

const initiateAccordion = (accordion: HTMLDivElement) => {
    const accordionItems = accordion.querySelectorAll<HTMLDetailsElement>('details.bi-details');
    accordionItems.forEach((accordionItem) => {
        const itemHash = `#${accordionItem.getAttribute('id')}`;

        if (itemHash === decodeURIComponent(window.location.hash)) {
            accordionItem.open = true;
        }

        accordionItem.addEventListener('toggle', (e) => {
            const toggleEvent = e as ToggleEvent;
            if (toggleEvent.newState === 'open' && itemHash !== decodeURIComponent(window.location.hash)) {
                history.replaceState(undefined, document.title, itemHash);
            } else if (
                toggleEvent.newState === 'closed' &&
                window.location.hash &&
                itemHash === decodeURIComponent(window.location.hash)
            ) {
                history.replaceState(undefined, document.title, ' ');
            }
        });
    });
};

onReady(() => {
    const accordions = document.querySelectorAll<HTMLDivElement>('.accordion-container');
    accordions.forEach(initiateAccordion);
});
